import { createAsyncThunk } from '@reduxjs/toolkit';
import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import {
  GetListActivityLogEEResponse,
  GetListActivityLogAgencyResponse,
  GetListActivityLogParams,
} from '../types';

const getListActivityLogEmployeeSubcontract = createAsyncThunk<
  GetListActivityLogEEResponse,
  GetListActivityLogParams
>(
  `/getListActivityLogEmployeeSubcontract`,
  async (
    params: GetListActivityLogParams,
    { rejectWithValue },
  ) => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.activityLog.subcontractor}`,
        { params },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

const getListActivityLogAgency = createAsyncThunk<
  GetListActivityLogAgencyResponse,
  GetListActivityLogParams
>(
  `/getListActivityLogAgency`,
  async (
    params: GetListActivityLogParams,
    { rejectWithValue },
  ) => {
    try {
      const response = await jwtAxios.get(`${endPoints.activityLog.agency}`, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

export const activityLogsAct = {
  getListActivityLogEmployeeSubcontract,
  getListActivityLogAgency,
};
